<template>
    <div>
        <v-text-field
            solo
            placeholder="Promocode"
            prepend-inner-icon="fa-percent"
            v-model="promocode"
            hide-details
            :error="promocodeField.error"
        >
            <template slot="append">
                <v-btn
                    @click="lc_validate_code"
                    class="ml-3"
                    :loading="promocodeLoading"
                    color="primary"
                    :error="promocodeField.error"
                    >Apply</v-btn
                >
            </template>
        </v-text-field>
        <div class="red--text mt-2" v-if="promocodeField.error">
            {{ promocodeField.error_message }}
        </div>
        <div
            class="green--text mt-2"
            v-if="Object.keys(promocodeInfo).length != 0"
        >
            You will Save
            {{ promocodeInfo.coupon.percent_off }}%<br />
        </div>
    </div>
</template>

<script>
import {baseDomain} from "../variables"
export default {
    name: "promo-code",
    props: ["info"],
    data() {
        return {
            promocode: "",
            promocodeField: { error: false, error_message: "" },
            promocodeInfo: {},
            promocodeLoading: false,
        };
    },
    methods: {
        async lc_validate_code(e) {
            e.preventDefault();
            this.promocodeLoading = true;
            console.log(this.promocode);
            let url =
                `${baseDomain}/validateTestPromoCode`;
            let response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ code: this.promocode }),
            });
            let data = await response.json();
            console.log(data);
            if (data.hasOwnProperty("error")) {
                this.promocodeField = data;
                this.promocodeInfo = {};
            } else {
                this.promocodeField = { error: false, error_message: "" };
                this.promocodeInfo = data;
                this.info(data);
            }
            this.promocodeLoading = false;
        },
    },
};
</script>

<style></style>
